import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { login, setIsLoggedIn } = useAuth();
  const navigate = useNavigate();

  const envUsername = process.env.REACT_APP_USER_NAME;
  const envPassword = process.env.REACT_APP_PASSWORD;

  const validateFields = () => {
    if (!username) {
      setErrorMessage("Please enter your username.");
      return false;
    }
    if (!password) {
      setErrorMessage("Please enter your password.");
      return false;
    }
    if (username !== envUsername || password !== envPassword) {
      setErrorMessage("Invalid username or password.");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateFields()) {
      setIsLoggedIn(true);
      toast.success("Login successful!");
      navigate("/");
    }
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
    if (e.target.value === envUsername) {
      setErrorMessage(""); // Clear error if username is correct
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (e.target.value === envPassword) {
      setErrorMessage(""); // Clear error if password is correct
    }
  };

  return (
    <div>
      <div className="inline-flex h-[100vh] w-[100vw] items-center justify-center overflow-hidden bg-white px-[470px] pb-[242px] pt-[200px]">
        <div className="relative h-[582px] w-[500px]">
          <div className="absolute left-[175px] top-0 h-[60px] w-[150px] overflow-hidden" />
          <div className="absolute left-[218px] top-[100px] text-center font-['Outfit'] text-2xl font-semibold text-[#222222]">
            Log in
          </div>

          <form
            onSubmit={handleSubmit}
            className="absolute left-0 top-[170px] w-full"
          >
            <div className="mb-2 font-['Outfit'] text-base font-medium text-[#666666]">
              Admin
            </div>
            <input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={handleUsernameChange}
              className="h-[60px] w-full rounded-[10px] border border-[#eeeeee] bg-[#f9f9f9] px-4"
            />
            {errorMessage && !username && (
              <div className="mt-1 text-sm text-red-600">{errorMessage}</div>
            )}

            <div className="mb-2 mt-4 font-['Outfit'] text-base font-medium text-[#666666]">
              Password
            </div>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={handlePasswordChange}
              className="h-[60px] w-full rounded-[10px] border border-[#eeeeee] bg-[#f9f9f9] px-4"
            />
            {errorMessage && !password && (
              <div className="mt-1 text-sm text-red-600">{errorMessage}</div>
            )}
            {errorMessage && username && password && (
              <div className="mt-1 text-sm text-red-600">{errorMessage}</div>
            )}

            <button
              type="submit"
              className="mt-6 h-[60px] w-full rounded-[10px] bg-[#fed107]"
            >
              <div className="text-center font-['Outfit'] text-lg font-medium text-[#09192c]">
                Log in
              </div>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
